export const STAGE = isLocal() ? 'local' : process.env.REACT_APP_STAGE

export const API_URLS = {
  local: 'http://localhost:8013',
  development: 'https://api-packoorang-dev.ur-internal.com',
  staging: 'https://api-staging.packoorang.com',
  production: 'https://api.packoorang.com',
}

export function isLocal() {
  return process.env.NODE_ENV !== 'production'
}

export const API_URL = API_URLS[STAGE]
